import { FC } from 'react';

import { Box, Stack, Typography } from '@mui/material';

import { useCountdown } from './hooks';
import useScreen from 'hooks/useScreen';
import useTranslates from 'utils/translate';

interface CountdownTimerProps {
  targetDate: string;
}

interface DateTimeDisplayProps {
  type: string;
  value: number;
}

interface ShowCounterProps {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}

const DateTimeDisplay: FC<DateTimeDisplayProps> = ({ value, type }) => {
  const { isMobile } = useScreen();

  return (
    <Box
      sx={{
        p: isMobile ? 1 : 2,
        width: isMobile ? 50 : 80,
        height: isMobile ? 50 : 80,
        bgcolor: '#F1F1F1',
        borderRadius: '10px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Typography fontSize={isMobile ? 8 : 14} fontWeight={400} color="common.black">
        {type}
      </Typography>
      <Typography fontSize={isMobile ? 16 : 28} fontWeight={700} color="common.black">
        {value}
      </Typography>
    </Box>
  );
};

const ShowCounter: FC<ShowCounterProps> = ({ days, hours, minutes, seconds }) => {
  const { translate } = useTranslates();

  return (
    <Stack direction="row" gap={1} mb={3}>
      <DateTimeDisplay value={days} type={translate('days')} />
      <DateTimeDisplay value={hours} type={translate('hours')} />
      <DateTimeDisplay value={minutes} type={translate('mins')} />
      <DateTimeDisplay value={seconds} type={translate('seconds')} />
    </Stack>
  );
};

const CountdownTimer: FC<CountdownTimerProps> = ({ targetDate }) => {
  const [days, hours, minutes, seconds] = useCountdown(targetDate);

  if (days + hours + minutes + seconds <= 0) {
    return null;
  } else {
    return <ShowCounter days={days} hours={hours} minutes={minutes} seconds={seconds} />;
  }
};

export default CountdownTimer;
